import { motion } from "framer-motion";
import { MessageCircle, Phone, MapPin, ShieldCheck, Users, Leaf, Target, Calendar, Clock } from "lucide-react";

const IMG = {
  socios: "https://customer-assets-4nw71qhi.emergentagent.net/job_club-premium-caza/artifacts/iu6k1r9e_4a0d813e-009a-4ff7-a1f7-a489b59440ed.png",
  rotativo: "https://customer-assets-4nw71qhi.emergentagent.net/job_club-premium-caza/artifacts/ulewoy26_0e8ca3bd-e9ca-432c-bc3d-fc538972de3c.png",
  paloma: "https://customer-assets-4nw71qhi.emergentagent.net/job_club-premium-caza/artifacts/oxu7v5ec_WhatsApp%20Image%202026-08-05%20at%2018.52.48.jpeg",
  reclamo: "https://customer-assets-4nw71qhi.emergentagent.net/job_club-premium-caza/artifacts/8js6vas3_706b8eca-ab73-48d1-9273-2c3990c24cea.png",
  aguardosBurguillos: "https://customer-assets-4nw71qhi.emergentagent.net/job_club-premium-caza/artifacts/1zei4g80_ChatGPT%20Image%205%20ago%202026%2C%2017_25_02.png",
  aguardosGuillena: "https://customer-assets-4nw71qhi.emergentagent.net/job_club-premium-caza/artifacts/fumrkx9u_WhatsApp%20Image%202026-08-05%20at%2017.18.35.jpeg",
};

const WA = (msg) =>
  `https://wa.me/34678783000?text=${encodeURIComponent(msg)}`;

const MONTERIA_POSTERS = [
  {
    id: "matacuelga",
    image: "https://customer-assets-4nw71qhi.emergentagent.net/job_club-premium-caza/artifacts/9ay2vqbk_a27b9581-68ce-421e-9dbd-e715e2dd047c.jpg",
    title: "Montería Santa Clara — Matacuelga",
    date: "31 de octubre de 2026",
    place: "Sierra de Aracena y Picos de Aroche (Huelva)",
    facts: ["500 hectáreas", "40 puestos · 10 rehalas", "Cupo: 1 ciervo, 1 cierva y jabalí libre", "Almuerzo incluido"],
  },
  {
    id: "charca-honda",
    image: "https://customer-assets-4nw71qhi.emergentagent.net/job_club-premium-caza/artifacts/4iqqbigg_9f67429b-be56-4629-a634-b2e106d59b50.jpg",
    title: "Montería Charca Honda",
    date: "7 de noviembre de 2026",
    place: "La Nava — Aracena (Huelva)",
    facts: ["Venado · Muflón · Jabalí", "Organiza: Monterías Alfredo Jacinto I L.C.", "Colabora: Cinegética Ruta del Agua"],
  },
];

const FECHAS_LA_NAVA = [
  { fecha: "07/11/2026", nombre: "Charca Honda" },
  { fecha: "05/12/2026", nombre: "La Lanchuela" },
  { fecha: "19/12/2026", nombre: "El Cazar, Tremedera y Los Llanos" },
  { fecha: "02/01/2027", nombre: "Las Cañadillas" },
  { fecha: "30/01/2027", nombre: "La Bujarda" },
];

const OFFERS = [
  {
    id: "rotativo",
    image: IMG.rotativo,
    overline: "Finca Los Perales · 15 tarjetas",
    title: "Tarjeta Temporada a Puesto Rotativo",
    price: "1.200 €",
    details: [
      { icon: Calendar, text: "Vigencia: 15 de noviembre al 7 de febrero (según veda)" },
      { icon: Target, text: "Días de caza: jueves y sábados" },
      { icon: Clock, text: "Horario: 7 a 12 y 16 a 20" },
    ],
    foot: "1.500 hras de finca · Llanos, encinares, zonas de agua y cascadas (Ruta del Agua)",
  },
  {
    id: "paloma",
    image: IMG.paloma,
    overline: "Media Veda · Guillena (Sevilla)",
    title: "Pases Caza de la Paloma Torcaz",
    price: "150 € / día completo",
    details: [
      { icon: Calendar, text: "Agosto: 22, 23, 27, 29 y 30" },
      { icon: Calendar, text: "Septiembre: 3, 5, 6, 10, 12, 13, 17, 19 y 20" },
      { icon: Clock, text: "De la salida a la puesta de sol · Jueves, sábados y domingos" },
    ],
    foot: "1.500 hras de finca · Comederos naturales, encinares y cascadas",
  },
  {
    id: "aguardos-burguillos",
    image: IMG.aguardosBurguillos,
    overline: "Coto en Burguillos (Sevilla)",
    title: "4 Acciones de Aguardos de Jabalí",
    price: "A consultar",
    details: [
      { icon: Target, text: "4 acciones de jabalí" },
      { icon: ShieldCheck, text: "Presencia de venado · Zonas habilitadas" },
      { icon: Clock, text: "Aguardos nocturnos" },
    ],
    foot: "Reserva y precio por WhatsApp: Antonio 678 783 000 · Javier 664 069 630",
  },
  {
    id: "aguardos-guillena",
    image: IMG.aguardosGuillena,
    overline: "Coto en Guillena (Sevilla)",
    title: "2 Acciones de Aguardos de Jabalí",
    price: "A consultar",
    details: [
      { icon: Target, text: "2 acciones de jabalí" },
      { icon: MapPin, text: "Coto en Guillena (Sevilla)" },
      { icon: Clock, text: "Aguardos nocturnos" },
    ],
    foot: "Reserva y precio por WhatsApp: Antonio 678 783 000 · Javier 664 069 630",
  },
  {
    id: "reclamo",
    image: IMG.reclamo,
    overline: "Finca Los Perales · 15 tarjetas",
    title: "Tarjeta para el Reclamo",
    price: "1.000 €",
    details: [
      { icon: Calendar, text: "Vigencia: 18 de enero al 23 de marzo" },
      { icon: Target, text: "Solo está permitido el reclamo macho" },
      { icon: ShieldCheck, text: "Todos los días de la semana en los periodos indicados" },
    ],
    foot: "Sorteo de 15 zonas de 100 hras · Llanos, encinares y zonas de agua (Ruta del Agua)",
  },
];

export default function AccionesCaza() {
  return (
    <div data-testid="acciones-caza-page">
      {/* HERO */}
      <section className="max-w-7xl mx-auto px-5 lg:px-8 pt-16 lg:pt-24 pb-10">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <p className="overline-gold mb-4">Temporada en curso</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl text-white font-light tracking-tight">
            Acciones de <span className="text-gold italic">Caza</span>
          </h1>
          <p className="mt-5 text-white/60 font-light max-w-2xl">
            Tarjetas, pases y jornadas en nuestras fincas de Guillena (Sevilla). Plazas limitadas — reserva por WhatsApp.
          </p>
        </motion.div>
      </section>

      {/* BUSCAMOS SOCIOS */}
      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-10">
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
          className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center border border-gold/25 bg-forest/50 p-6 lg:p-10" data-testid="buscamos-socios-block">
          <div className="order-2 lg:order-1">
            <p className="overline-gold mb-3">Club federado · Guillena (Sevilla)</p>
            <h2 className="text-3xl lg:text-4xl text-white font-light">Buscamos <span className="text-gold italic">socios</span></h2>
            <p className="mt-4 text-white/65 text-sm font-light leading-relaxed">
              Queremos crear un club de caza y buscamos socios para adquirir terrenos y cazarlos como club de caza
              federado en Guillena (Sevilla). Caza menor y mayor: paloma torcaz, conejo, perdiz, jabalí, ciervo y más especies.
            </p>
            <ul className="mt-6 space-y-3 text-sm text-white/70 font-light">
              <li className="flex items-center gap-3"><Leaf size={16} className="text-gold shrink-0" /> Respeto por la naturaleza y gestión sostenible de los terrenos</li>
              <li className="flex items-center gap-3"><ShieldCheck size={16} className="text-gold shrink-0" /> Caza ética y responsable, club federado con normativa vigente</li>
              <li className="flex items-center gap-3"><Users size={16} className="text-gold shrink-0" /> Compañerismo, buen ambiente y gestión democrática</li>
              <li className="flex items-center gap-3"><MapPin size={16} className="text-gold shrink-0" /> Zona de actuación: Guillena (Sevilla) y alrededores</li>
            </ul>
            <a href={WA("Hola, quiero información para hacerme socio del club de caza (Guillena).")} target="_blank" rel="noopener noreferrer"
              className="btn-gold-solid mt-8" data-testid="buscamos-socios-cta">
              <MessageCircle size={16} /> Únete al Proyecto
            </a>
          </div>
          <div className="order-1 lg:order-2">
            <img src={IMG.socios} alt="Buscamos socios — Club de caza federado Guillena" className="w-full border border-white/10" data-testid="buscamos-socios-poster" />
          </div>
        </motion.div>
      </section>

      {/* MONTERÍAS 2026/2027 */}
      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-14" data-testid="monterias-section">
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
          <p className="overline-gold mb-3">Monterías · Temporada 2026/2027</p>
          <h2 className="text-3xl lg:text-4xl text-white font-light">Monterías <span className="text-gold italic">programadas</span></h2>
          <p className="mt-4 text-white/60 font-light max-w-2xl">
            Varias monterías confirmadas en Huelva para la temporada 2026/2027. Plazas limitadas — reserva tu puesto por WhatsApp.
          </p>
        </motion.div>
        <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-8">
          {MONTERIA_POSTERS.map((m, i) => (
            <motion.article key={m.id} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: i * 0.08 }}
              className="card-dark overflow-hidden" data-testid={`monteria-${m.id}`}>
              <div className="relative overflow-hidden group">
                <img src={m.image} alt={m.title} className="w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="p-7">
                <p className="overline-gold !text-[10px] mb-2">{m.date} · {m.place}</p>
                <h3 className="text-2xl text-white font-medium">{m.title}</h3>
                <ul className="mt-4 space-y-2">
                  {m.facts.map((f) => (
                    <li key={f} className="flex items-center gap-3 text-white/65 text-sm font-light">
                      <Target size={14} strokeWidth={1.5} className="text-gold shrink-0" /> {f}
                    </li>
                  ))}
                </ul>
                <a href={WA(`Hola, quiero reservar puesto para la ${m.title} (${m.date}).`)} target="_blank" rel="noopener noreferrer"
                  className="btn-gold mt-6 w-full" data-testid={`monteria-reserve-${m.id}`}>
                  <MessageCircle size={15} /> Reservar Puesto
                </a>
              </div>
            </motion.article>
          ))}
        </div>

        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
          className="mt-10 border border-gold/25 bg-forest/60 p-7 lg:p-10" data-testid="monterias-la-nava">
          <p className="overline-gold mb-2">La Nava · Aracena</p>
          <h3 className="text-2xl text-white font-light">Más fechas de la temporada</h3>
          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
            {FECHAS_LA_NAVA.map((f) => (
              <div key={f.fecha} className="bg-carbon/60 border border-white/10 px-5 py-4" data-testid={`monteria-fecha-${f.fecha.replaceAll("/", "-")}`}>
                <p className="font-heading text-2xl text-gold leading-none">{f.fecha}</p>
                <p className="mt-2 text-white/80 text-sm font-light">{f.nombre}</p>
              </div>
            ))}
          </div>
          <a href={WA("Hola, quiero información sobre las monterías de La Nava (temporada 2026/2027).")} target="_blank" rel="noopener noreferrer"
            className="btn-gold mt-7" data-testid="monterias-la-nava-cta">
            <MessageCircle size={15} /> Información y Reservas
          </a>
        </motion.div>
      </section>

      {/* OFERTAS */}
      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-14">
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
          <p className="overline-gold mb-3">Ofertas de temporada</p>
          <h2 className="text-3xl lg:text-4xl text-white font-light">Tarjetas y pases <span className="text-gold italic">disponibles</span></h2>
        </motion.div>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
          {OFFERS.map((o, i) => (
            <motion.article key={o.id} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: i * 0.08 }}
              className="card-dark overflow-hidden flex flex-col" data-testid={`offer-card-${o.id}`}>
              <div className="relative overflow-hidden group">
                <img src={o.image} alt={o.title} className="w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="p-7 flex flex-col flex-1">
                <p className="overline-gold !text-[10px] mb-2">{o.overline}</p>
                <h3 className="text-2xl text-white font-medium">{o.title}</h3>
                <p className="font-heading text-4xl text-gold mt-3" data-testid={`offer-price-${o.id}`}>{o.price}</p>
                <ul className="mt-5 space-y-2.5 flex-1">
                  {o.details.map((d) => (
                    <li key={d.text} className="flex items-start gap-3 text-white/65 text-sm font-light">
                      <d.icon size={15} strokeWidth={1.5} className="text-gold mt-0.5 shrink-0" /> {d.text}
                    </li>
                  ))}
                </ul>
                <p className="mt-4 text-white/40 text-xs font-light">{o.foot}</p>
                <a href={WA(`Hola, me interesa: ${o.title} (${o.price}). ¿Me dais más información?`)} target="_blank" rel="noopener noreferrer"
                  className="btn-gold mt-6 w-full" data-testid={`offer-reserve-${o.id}`}>
                  <MessageCircle size={15} /> Reservar por WhatsApp
                </a>
              </div>
            </motion.article>
          ))}
        </div>
      </section>

      {/* CONTACTO */}
      <section className="border-t border-white/5 bg-[#0D0D0D]">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 text-center">
          <p className="overline-gold mb-4">Teléfonos de contacto</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-14">
            <a href="tel:+34678783000" className="flex items-center gap-3 group" data-testid="contact-antonio">
              <Phone size={20} strokeWidth={1.5} className="text-gold" />
              <span className="text-left">
                <span className="block text-[10px] uppercase tracking-[0.2em] text-white/40">Antonio Zambrano</span>
                <span className="text-xl text-white group-hover:text-gold transition-colors duration-200">678 783 000</span>
              </span>
            </a>
            <a href="tel:+34664069630" className="flex items-center gap-3 group" data-testid="contact-javier">
              <Phone size={20} strokeWidth={1.5} className="text-gold" />
              <span className="text-left">
                <span className="block text-[10px] uppercase tracking-[0.2em] text-white/40">Javier Zambrano</span>
                <span className="text-xl text-white group-hover:text-gold transition-colors duration-200">664 069 630</span>
              </span>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
